module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "profile"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "offset-md3": "",
      "md6": "",
      "offset-lg4": "",
      "lg4": ""
    }
  }, [_c('v-card', [_c('v-card-row', {
    attrs: {
      "actions": "",
      "img": "../../static/milkyway.png",
      "height": "300px"
    }
  }, [_c('v-card-text', {
    staticClass: "white--text pa-0"
  }, [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-card-row', {
    staticClass: "pl-5 pt-5",
    attrs: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "display-1 pl-5 pt-5"
  }, [_vm._v(_vm._s(_vm.user.firstname))])])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', {
    staticClass: "indigo--text"
  }, [_vm._v("mail")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Personal")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar'), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("One ( 1 )")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Table Number")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', {
    staticClass: "indigo--text"
  }, [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.user.school))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("School")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15a1fec4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 78
// module chunks = 1